var modal = document.getElementById("geoModal");

// --- Remembering the visitor's store choice -------------------------------
// Persist the choice in a cookie (not sessionStorage, which the browser wipes
// when the tab closes — that's why the modal re-prompted on every new visit).
// A 30-day expiry means the location is re-verified periodically for people
// who actually move/travel, instead of being silenced forever.
var GEO_COOKIE = "geoStoreChosen";
var GEO_COOKIE_DAYS = 30;

function setGeoChoice(days) {
  var d = new Date();
  d.setTime(d.getTime() + days * 864e5); // days -> ms
  document.cookie =
    GEO_COOKIE + "=1; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
}

function hasGeoChoice() {
  return document.cookie.indexOf(GEO_COOKIE + "=1") !== -1;
}

// Lock/unlock background scroll while the modal is open. Without this the
// page keeps scrolling behind the popup, which on mobile makes the "fixed"
// modal appear to drift/reposition as the browser's toolbar shows/hides
// during the scroll gesture (classic iOS/Android position:fixed jank).
function openGeoModal() {
  // "flex" (not "block") so .modal's align-items/justify-content actually
  // center .modal-content vertically and horizontally on screen.
  modal.style.display = "flex";
  document.documentElement.classList.add("geo-modal-open");
  document.body.classList.add("geo-modal-open");
}

// There is no close (X) button and clicking the overlay does NOT dismiss
// the modal on purpose: the visitor is required to pick a location from
// the list.
//
// Bug fix: each link's href in Shopify Admin is just the target store's
// root domain (e.g. https://masayacompany.com.ni/), so picking a location
// always dropped the visitor on that store's homepage — even if they were
// looking at a specific product. Instead, keep them on the equivalent page:
// take the chosen store's domain/locale prefix but swap in the CURRENT
// page's path + query string before navigating.
//
// This same bug also existed in the header's own country-changer dropdown
// (snippets/country-changer.liquid on desktop, snippets/country-changer-mobile.liquid
// on mobile) — it renders the exact same linklist but had no click handler
// at all, so it always did a plain navigation straight to the bare root
// domain regardless of which page (product, collection, etc.) the visitor
// was on. attachSameLocationRedirect() below is shared across the geo
// modal AND both header country-changers so all three stay on the
// equivalent page, on every template, not just the homepage.
// Strip a leading locale segment (e.g. "/nl-nl", "/en-us") off a pathname so
// we're left with the "content" path only. Without this, re-selecting the
// market you're already on double-appends the locale (/nl-nl + /nl-nl =
// /nl-nl/nl-nl -> 404), and switching to a root-domain market (e.g. USA)
// re-appends the CURRENT locale path instead of landing on that market's
// equivalent page, making the switch look like it silently does nothing.
function stripLocalePrefix(pathname) {
  return pathname.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, "");
}

function attachSameLocationRedirect(selector) {
  var links = document.querySelectorAll(selector);
  for (var i = 0; i < links.length; i++) {
    links[i].addEventListener("click", function (event) {
      // Remember the choice on the CURRENT domain so it isn't re-prompted here.
      setGeoChoice(GEO_COOKIE_DAYS);

      try {
        var target = new URL(this.href);
        // Old redirect-only domains (e.g. masayacompany.pa -> masayaco.pa) make
        // Shopify show an "Are you sure you want to leave?" page on the redirect
        // hop. Go straight to each store's primary domain to skip it.
        var primaryHosts = {
          "masayacompany.pa": "masayaco.pa",
          "www.masayacompany.pa": "masayaco.pa",
          "masayacompany.cr": "masayaco.cr",
          "www.masayacompany.cr": "masayaco.cr",
          "masayacompany.com": "www.masayaco.com",
          "www.masayacompany.com": "www.masayaco.com"
        };
        if (primaryHosts[target.hostname]) {
          target.hostname = primaryHosts[target.hostname];
        }
        var currentContentPath = stripLocalePrefix(window.location.pathname);

        if (target.pathname === "/" || target.pathname === "") {
          // Link is just the bare domain root — land on that market's
          // equivalent content path (empty means its own root).
          target.pathname = currentContentPath || "/";
        } else {
          // Link has its own prefix (e.g. a locale folder like /nl-nl) —
          // keep that prefix and append the equivalent content path after
          // it, instead of appending the current path (which still has the
          // OLD locale prefix on it and would double it up).
          target.pathname =
            target.pathname.replace(/\/$/, "") + currentContentPath;
        }
        target.search = window.location.search;
        // Cross-domain marker: cookies can't be shared across our different
        // store TLDs (.com vs .com.ni etc.), so tell the DESTINATION store the
        // choice was already made. getLocation() honors this on arrival and
        // sets its own cookie, so the destination doesn't re-prompt either.
        target.searchParams.set("geo", "1");

        event.preventDefault();
        window.location.href = target.toString();
      } catch (e) {
        // If anything about this URL is unexpected, fall back to the
        // original plain link behavior rather than breaking navigation.
        console.log("geo-location redirect fallback:", e);
      }
    });
  }
}

attachSameLocationRedirect(".geo-location-list a");
attachSameLocationRedirect(".uaf-announcement-country-changer a");
attachSameLocationRedirect(".uaf-announcement-country-changer-mobile a");

// Prevent iOS/Android rubber-band scrolling on the dark overlay itself
// (touches inside .modal-content, e.g. scrolling the list, still work).
modal.addEventListener(
  "touchmove",
  function (event) {
    if (event.target === modal) {
      event.preventDefault();
    }
  },
  { passive: false }
);

function getLocation() {
  // Arrived from a location the visitor just picked on another store domain:
  // record the choice on THIS domain and skip the modal.
  if (new URLSearchParams(window.location.search).has("geo")) {
    setGeoChoice(GEO_COOKIE_DAYS);
    return;
  }

  // Already chose within the last 30 days on this domain — don't prompt again.
  if (hasGeoChoice()) {
    console.log("Store already chosen")
    return;
  }

  console.log("GEOLOCATION")
  $.get("https://ipinfo.io", function(response) {
        console.log(response.city, response.country);
        // Show the picker when the visitor's country doesn't match this store
        // AND either side is a Central America store/visitor (NI/CR/PA).
        // - NI/CR/PA visitor on another store (e.g. the US site) -> show (as before)
        // - Visitor from anywhere (e.g. US) on the NI/CR/PA store -> show (was missing:
        //   a US visitor on the Nica site never got the selector)
        // - Visitor already on their own country's store -> no popup
        // window.GEO_STORE_COUNTRY is set in snippets/geolocation-modal.liquid.
        var CA = ["NI", "CR", "PA"];
        var visitorCountry = response.country;
        var storeCountry = window.GEO_STORE_COUNTRY || "";
        var isCA = function (c) { return CA.indexOf(c) !== -1; };
        if (!visitorCountry || visitorCountry === storeCountry) return;
        if (!isCA(visitorCountry) && !isCA(storeCountry)) return;
        // Content is now a static "select your location" list rendered in
        // snippets/geolocation-modal.liquid (from the "country-changer" linklist),
        // so we only need to decide whether to show the modal.
        openGeoModal();

    }, "jsonp");

}

function defer(method) {
  console.log("DEFER")
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}


defer(getLocation);

